export type UserStorageKey =
    "AuthToken" |
    "MicrosoftTeamsContext" |
    "MicrosoftTeamsUserJoinedTeamsInfo" |
    "MostRecentTeamId" |
    "InstallId" |
    "ShareWithTeamAssignedShifts" |
    "ShareWithTeamOpenShifts" |
    "ShareWithTeamPreference" |
    "ScheduleGrouped" |
    "ShowStaffPer30Rows" |
    "TelemetryRegion" |
    "ExportTimeClockReportOption";
/**
 * These enums are used as keys for the UserStorageService
 */
export enum UserStorageKeys {
    AuthToken = "AuthToken",
    MicrosoftTeamsContext = "MicrosoftTeamsContext",
    MicrosoftTeamsUserJoinedTeamsInfo = "MicrosoftTeamsUserJoinedTeamsInfo",
    MostRecentTeamId = "MostRecentTeamId",
    InstallId = "InstallId",
    ShareWithTeamAssignedShifts = "ShareWithTeamAssignedShifts",
    ShareWithTeamOpenShifts = "ShareWithTeamOpenShifts",
    ScheduleGrouped = "ScheduleGrouped",
    ShowStaffPer30Rows = "ShowStaffPer30Rows",

    /**
     * The telemetry region
     */
    TelemetryRegion = "TelemetryRegion",
    /**
     * Store the option selected for exporting time clock report. Legacy report or new report
     */
    ExportTimeClockReportOption = "ExportTimeClockReportOption"
}